import { render, staticRenderFns } from "./TextFade.vue?vue&type=template&id=c69ef5e6&scoped=true&"
import script from "./TextFade.vue?vue&type=script&lang=js&"
export * from "./TextFade.vue?vue&type=script&lang=js&"
import style0 from "./TextFade.vue?vue&type=style&index=0&id=c69ef5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69ef5e6",
  null
  
)

export default component.exports